/* ==========================================================================
   Pretty Custom Theme | enLighten - theme.js
   Vanilla JS, no dependencies. Ported from the approved design (main.js, home.js, product.js)
   and extended with Shopify cart, variant, predictive search and section rendering behaviour.
   ========================================================================== */
(function () {
  'use strict';

  var T = window.theme || { routes: {}, settings: {}, strings: {} };
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches || document.body.classList.contains('reduce-motion');

  /* ---------- Utilities ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function debounce(fn, wait) { var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, wait); }; }
  function parseHTML(html) { return new DOMParser().parseFromString(html, 'text/html'); }

  function formatMoney(cents, format) {
    format = format || T.moneyFormat || '${{amount}}';
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    function num(n, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision; thousands = thousands || ','; decimal = decimal || '.';
      if (isNaN(n) || n == null) return '0';
      n = (n / 100.0).toFixed(precision);
      var parts = n.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var dec = parts[1] ? decimal + parts[1] : '';
      return whole + dec;
    }
    var match = format.match(placeholderRegex);
    var type = match ? match[1] : 'amount';
    switch (type) {
      case 'amount': value = num(cents, 2); break;
      case 'amount_no_decimals': value = num(cents, 0); break;
      case 'amount_with_comma_separator': value = num(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = num(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = num(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = num(cents, 0, ' ', ','); break;
      default: value = num(cents, 2);
    }
    return format.replace(placeholderRegex, value);
  }

  function fetchSection(url) {
    return fetch(url, { headers: { 'Accept': 'text/html' } }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); });
  }

  function updateCartCount() {
    fetch(T.routes.cart + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.classList.toggle('is-empty', cart.item_count === 0);
        });
        var floating = $('[data-floating-cart]');
        if (floating) {
          if (lastCartCount !== null && cart.item_count > lastCartCount) {
            floating.classList.remove('is-bumped');
            void floating.offsetWidth;
            floating.classList.add('is-bumped');
          }
          floating.setAttribute('aria-label', (T.strings.cartTitle || 'Cart') + ', ' + cart.item_count);
        }
        lastCartCount = cart.item_count;
      }).catch(function () {});
  }
  var lastCartCount = null;

  /* ---------- Toasts (added to cart / wishlist): slide in, auto-close with a progress line, pause on hover ---------- */
  function closeToast(toast) {
    if (!toast || toast.hidden) return;
    clearTimeout(toast._timer);
    toast.classList.remove('is-visible');
    setTimeout(function () { if (!toast.classList.contains('is-visible')) toast.hidden = true; }, reduceMotion ? 0 : 300);
  }
  function openToast(toast, opts) {
    if (!toast) return;
    $$('.cart-toast').forEach(function (t) { if (t !== toast) closeToast(t); });
    var duration = opts.duration || 5000;
    $('.cart-toast__text', toast).textContent = opts.title || '';
    var sub = $('.cart-toast__sub', toast);
    sub.textContent = opts.sub || '';
    sub.hidden = !opts.sub;
    var img = $('.cart-toast__img', toast), icon = $('.cart-toast__icon', toast);
    if (img) {
      img.hidden = !opts.image;
      if (opts.image) img.src = opts.image;
      if (icon) icon.hidden = !!opts.image;
    }
    toast.classList.toggle('is-removed', !!opts.removed);
    toast.hidden = false;
    toast.style.setProperty('--toast-duration', duration + 'ms');
    toast.classList.remove('is-visible');
    void toast.offsetWidth;
    toast.classList.add('is-visible');
    clearTimeout(toast._timer);
    toast._timer = setTimeout(function () { closeToast(toast); }, duration);
    if (!toast._wired) {
      toast._wired = true;
      toast.addEventListener('mouseenter', function () { clearTimeout(toast._timer); toast.classList.add('is-paused'); });
      toast.addEventListener('mouseleave', function () { toast.classList.remove('is-paused'); toast._timer = setTimeout(function () { closeToast(toast); }, 2000); });
    }
  }
  function showToast(title, sub, image) {
    openToast($('#CartToast'), { title: title, sub: sub, image: image });
  }
  document.addEventListener('click', function (e) {
    var closeBtn = e.target.closest('.cart-toast__close');
    if (closeBtn) closeToast(closeBtn.closest('.cart-toast'));
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') $$('.cart-toast.is-visible').forEach(closeToast);
  });

  /* ---------- Header: height sync, scroll state, mobile menu ---------- */
  var header = $('[data-header]');
  function syncHeaderHeight() {
    if (header) document.documentElement.style.setProperty('--header-h', header.offsetHeight + 'px');
  }
  syncHeaderHeight();
  window.addEventListener('resize', debounce(syncHeaderHeight, 100));
  window.addEventListener('load', syncHeaderHeight);

  if (header && header.hasAttribute('data-scroll-state')) {
    var threshold = parseInt(header.getAttribute('data-threshold'), 10) || 400;
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > threshold); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  var menu = $('[data-mobile-menu]');
  var toggles = $$('[data-menu-toggle]');
  var lastFocus = null;
  function setMenu(open) {
    if (!menu) return;
    menu.classList.toggle('is-open', open);
    menu.setAttribute('aria-hidden', String(!open));
    document.body.classList.toggle('menu-open', open);
    toggles.forEach(function (t) { t.setAttribute('aria-expanded', String(open)); });
    if (open) {
      lastFocus = document.activeElement;
      var first = $('.drawer-close', menu);
      if (first) first.focus();
    } else if (lastFocus) {
      lastFocus.focus();
    }
  }
  toggles.forEach(function (t) { t.addEventListener('click', function () { setMenu(!menu.classList.contains('is-open')); }); });

  /* Mobile: search icon reveals the header search bar below the logo row */
  var searchToggle = $('[data-search-toggle]');
  if (header && searchToggle) {
    var setSearch = function (open) {
      header.classList.toggle('is-search-open', open);
      searchToggle.setAttribute('aria-expanded', String(open));
      searchToggle.setAttribute('aria-label', searchToggle.getAttribute(open ? 'data-label-close' : 'data-label-open'));
      syncHeaderHeight();
      var input = $('.nav-search__input', header);
      if (open && input) input.focus();
    };
    searchToggle.addEventListener('click', function () { setSearch(!header.classList.contains('is-search-open')); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && header.classList.contains('is-search-open')) { setSearch(false); searchToggle.focus(); }
    });
  }
  $$('[data-menu-close]').forEach(function (el) { el.addEventListener('click', function () { setMenu(false); }); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && menu && menu.classList.contains('is-open')) setMenu(false);
    if (e.key === 'Tab' && menu && menu.classList.contains('is-open')) {
      var focusables = $$('a[href], button, input, [tabindex]:not([tabindex="-1"])', menu).filter(function (el) { return !el.hidden && el.offsetParent !== null; });
      if (!focusables.length) return;
      var firstEl = focusables[0], lastEl = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === firstEl) { e.preventDefault(); lastEl.focus(); }
      else if (!e.shiftKey && document.activeElement === lastEl) { e.preventDefault(); firstEl.focus(); }
    }
  });

  /* ---------- Smooth anchor scrolling ---------- */
  function smoothScrollTo(el) {
    var startY = window.scrollY;
    var offset = (header ? header.offsetHeight : 0) + 16;
    var targetY = startY + el.getBoundingClientRect().top - offset;
    if (reduceMotion || T.settings.smoothScroll === false) { window.scrollTo(0, targetY); return; }
    var dist = targetY - startY;
    var duration = Math.min(1400, Math.max(600, Math.abs(dist) * 0.9));
    var ease = function (t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; };
    var start = null;
    function step(ts) {
      if (start === null) start = ts;
      var p = Math.min(1, (ts - start) / duration);
      window.scrollTo(0, startY + dist * ease(p));
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[data-scroll], a[href^="#"]');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    var hashIndex = href.indexOf('#');
    if (hashIndex === -1) return;
    var path = href.slice(0, hashIndex);
    var id = href.slice(hashIndex + 1);
    if (!id) return;
    var samePage = !path || path === '/' && location.pathname === '/' || path === location.pathname;
    if (!samePage) return;
    var el = document.getElementById(id);
    if (!el) return;
    e.preventDefault();
    var inMenu = menu && menu.contains(a) && menu.classList.contains('is-open');
    if (inMenu) setMenu(false);
    history.replaceState(null, '', '#' + id);
    setTimeout(function () { smoothScrollTo(el); }, inMenu ? 260 : 0);
  });

  /* ---------- Back to top ---------- */
  var backToTop = $('[data-back-to-top]');
  if (backToTop) {
    var ticking = false;
    var updateBackToTop = function () {
      ticking = false;
      var max = document.documentElement.scrollHeight - window.innerHeight;
      var y = window.scrollY;
      backToTop.classList.toggle('is-visible', y > Math.min(600, window.innerHeight * 0.75));
      backToTop.style.setProperty('--progress', max > 0 ? Math.min(100, (y / max) * 100).toFixed(1) : 0);
    };
    var requestBackToTop = function () {
      if (!ticking) { ticking = true; requestAnimationFrame(updateBackToTop); }
    };
    window.addEventListener('scroll', requestBackToTop, { passive: true });
    window.addEventListener('resize', requestBackToTop);
    updateBackToTop();
    backToTop.addEventListener('click', function () {
      var main = document.getElementById('MainContent');
      var instant = reduceMotion || T.settings.smoothScroll === false;
      window.scrollTo({ top: 0, left: 0, behavior: instant ? 'instant' : 'smooth' });
      if (main) main.focus({ preventScroll: true });
    });
  }

  /* ---------- Specifications: groups collapse on mobile, always open on desktop ---------- */
  var specsMobile = window.matchMedia('(max-width: 749px)');
  function initSpecs(section) {
    var groups = $$('details[data-spec-group]', section);
    if (!groups.length) return;
    var apply = function () {
      groups.forEach(function (d, i) { d.open = specsMobile.matches ? i === 0 : true; });
    };
    apply();
    if (specsMobile.addEventListener) specsMobile.addEventListener('change', apply);
    groups.forEach(function (d) {
      $('summary', d).addEventListener('click', function (e) { if (!specsMobile.matches) e.preventDefault(); });
    });
  }
  $$('[data-specs]').forEach(initSpecs);

  /* ---------- Parallax: [data-parallax] layers drift slower than the page while their section is on screen ---------- */
  function initParallax(scope) {
    if (reduceMotion) return;
    var layers = $$('[data-parallax]', scope).filter(function (l) { return !l.hasAttribute('data-parallax-ready'); });
    if (!layers.length) return;
    var SPEED = 0.18;
    var active = [], ticking = false;
    function update() {
      ticking = false;
      var vh = window.innerHeight;
      active.forEach(function (layer) {
        var box = layer.parentElement.getBoundingClientRect();
        var offset = (box.top + box.height / 2 - vh / 2) * -SPEED;
        var max = box.height * 0.14;
        offset = Math.max(-max, Math.min(max, offset));
        layer.style.setProperty('--parallax-y', offset.toFixed(1) + 'px');
      });
    }
    function request() { if (!ticking && active.length) { ticking = true; requestAnimationFrame(update); } }
    layers.forEach(function (layer) {
      layer.setAttribute('data-parallax-ready', '');
      if (window.IntersectionObserver) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            var i = active.indexOf(layer);
            if (en.isIntersecting && i === -1) active.push(layer);
            if (!en.isIntersecting && i > -1) active.splice(i, 1);
          });
          request();
        }, { rootMargin: '100px 0px' }).observe(layer.parentElement);
      } else {
        active.push(layer);
      }
    });
    window.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', request);
    request();
  }
  initParallax(document);

  /* ---------- Store policy pages: "On this page" list built from the policy headings ---------- */
  (function initPolicyToc() {
    var toc = $('[data-policy-toc]');
    var list = $('[data-policy-toc-list]');
    var body = $('.shopify-policy__body');
    if (!toc || !list || !body) return;
    var heads = $$('h2, h3', body).filter(function (h) { return h.textContent.trim().length > 1; });
    if (heads.length < 3) return;
    var links = heads.map(function (h, i) {
      if (!h.id) h.id = 'policy-' + (i + 1) + '-' + h.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 40);
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent.trim().toLowerCase().replace(/(^|\s)\S/g, function (s) { return s.toUpperCase(); });
      li.appendChild(a);
      list.appendChild(li);
      return a;
    });
    toc.hidden = false;
    document.body.classList.add('has-policy-toc');
    if (window.IntersectionObserver) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var idx = heads.indexOf(en.target);
          links.forEach(function (l, i) { l.classList.toggle('is-active', i === idx); });
        });
      }, { rootMargin: '-20% 0px -70% 0px' });
      heads.forEach(function (h) { io.observe(h); });
    }
  })();

  /* ---------- Image magnifier: button toggles a round lens that follows the pointer / finger ---------- */
  function initZoom(section) {
    var box = $('[data-gallery-main]', section);
    var btn = box && $('[data-zoom-toggle]', box);
    var lens = box && $('[data-zoom-lens]', box);
    if (!box || !btn || !lens || box.hasAttribute('data-zoom-ready')) return;
    box.setAttribute('data-zoom-ready', '');
    var ZOOM = 2.5, on = false, loadedSrc = '';
    function activeSlide() { return $('.gallery-slide.is-active', box) || $('.gallery-slide:not([hidden])', box); }
    // Rendered image rectangle inside the box (the image uses object-fit: contain)
    function imageRect(img) {
      var r = img.getBoundingClientRect();
      var nw = img.naturalWidth || r.width, nh = img.naturalHeight || r.height;
      var scale = Math.min(r.width / nw, r.height / nh);
      var w = nw * scale, h = nh * scale;
      return { left: r.left + (r.width - w) / 2, top: r.top + (r.height - h) / 2, width: w, height: h };
    }
    function setState(next) {
      var slide = activeSlide();
      if (next && (!slide || !slide.getAttribute('data-zoom-src'))) next = false;
      on = next;
      box.classList.toggle('is-zooming', on);
      btn.setAttribute('aria-pressed', String(on));
      var label = btn.getAttribute(on ? 'data-label-off' : 'data-label-on');
      btn.setAttribute('aria-label', label); btn.setAttribute('title', label);
      lens.classList.remove('is-visible');
      if (on) {
        var src = slide.getAttribute('data-zoom-src');
        if (src !== loadedSrc) { lens.style.backgroundImage = 'url("' + src + '")'; loadedSrc = src; }
      }
    }
    function move(e) {
      if (!on) return;
      var img = $('img', activeSlide());
      if (!img) return;
      var rect = imageRect(img), boxRect = box.getBoundingClientRect();
      var x = e.clientX - rect.left, y = e.clientY - rect.top;
      if (x < 0 || y < 0 || x > rect.width || y > rect.height) { lens.classList.remove('is-visible'); return; }
      var size = lens.offsetWidth || 200;
      lens.style.left = (e.clientX - boxRect.left - size / 2) + 'px';
      lens.style.top = (e.clientY - boxRect.top - size / 2) + 'px';
      lens.style.backgroundSize = (rect.width * ZOOM) + 'px ' + (rect.height * ZOOM) + 'px';
      lens.style.backgroundPosition = (-(x * ZOOM - size / 2)) + 'px ' + (-(y * ZOOM - size / 2)) + 'px';
      lens.classList.add('is-visible');
    }
    btn.addEventListener('click', function (e) { e.stopPropagation(); setState(!on); });
    box.addEventListener('pointermove', move);
    box.addEventListener('pointerdown', function (e) { if (on && e.target !== btn && !btn.contains(e.target)) move(e); });
    box.addEventListener('pointerleave', function () { lens.classList.remove('is-visible'); });
    document.addEventListener('click', function (e) { if (on && !box.contains(e.target)) setState(false); });
    document.addEventListener('keydown', function (e) { if (on && e.key === 'Escape') setState(false); });
    // Switching image (thumbnail / variant) turns the lens off so it never shows the wrong photo
    if (window.MutationObserver) new MutationObserver(function () { if (on) setState(false); }).observe(box, { subtree: true, attributes: true, attributeFilter: ['hidden'] });
  }
  $$('[data-product-section]').forEach(initZoom);

  /* ---------- Sticky add to cart: shows once the main buy button has scrolled above the viewport ---------- */
  function initStickyAtc(section) {
    var bar = $('[data-sticky-atc]', section);
    var target = $('[data-add-to-cart]', section) || $('.enquiry', section);
    if (!bar || !target || !window.IntersectionObserver) return;
    var footer = $('.site-footer') || $('#shopify-section-footer');
    var pastButton = false, nearFooter = false;
    var update = function () {
      var show = pastButton && !nearFooter && !document.body.classList.contains('menu-open');
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', String(!show));
      $$('a, button', bar).forEach(function (el) { el.tabIndex = show ? 0 : -1; });
      document.body.classList.toggle('has-sticky-atc', show);
    };
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      pastButton = !e.isIntersecting && e.boundingClientRect.top < 0;
      update();
    }).observe(target);
    if (footer) {
      new IntersectionObserver(function (entries) { nearFooter = entries[0].isIntersecting; update(); }).observe(footer);
    }

    // Jump links: Overview (main description, expanded), Specifications and Downloads when those sections exist
    var targets = {
      overview: function () { return $('[id^="Desc-"]', section); },
      specs: function () { return $('[id^="Specifications-"]'); },
      downloads: function () { return $('[id^="Downloads-"]'); }
    };
    $$('[data-sticky-jump]', bar).forEach(function (link) {
      var key = link.getAttribute('data-sticky-jump');
      var el = targets[key] && targets[key]();
      if (!el) { link.remove(); return; }
      if (!el.id) return;
      link.hidden = false;
      link.setAttribute('href', '#' + el.id);
      link.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (key === 'overview') {
          var more = el.closest('[data-readmore]');
          var toggle = more && more.classList.contains('is-clamped') && $('[data-readmore-toggle]', more);
          if (toggle) toggle.click();
          el = more || el;
        }
        smoothScrollTo(el);
      });
    });
  }
  $$('[data-product-section]').forEach(initStickyAtc);

  /* ---------- Read more: long product descriptions collapse to a preview ---------- */
  function initReadMore(root) {
    var body = $('[data-readmore-body]', root);
    var btn = $('[data-readmore-toggle]', root);
    if (!body || !btn || root.hasAttribute('data-readmore-ready')) return;
    root.setAttribute('data-readmore-ready', '');
    var check = function () {
      if (root.classList.contains('is-open')) return;
      root.classList.remove('is-clamped');
      var tooLong = body.scrollHeight > 260;
      root.classList.toggle('is-clamped', tooLong);
      btn.hidden = !tooLong;
    };
    btn.addEventListener('click', function () {
      var open = !root.classList.contains('is-open');
      root.classList.toggle('is-open', open);
      root.classList.toggle('is-clamped', !open);
      btn.setAttribute('aria-expanded', String(open));
      $('span', btn).textContent = btn.getAttribute(open ? 'data-label-less' : 'data-label-more');
      if (!open) root.scrollIntoView({ block: 'nearest', behavior: reduceMotion ? 'auto' : 'smooth' });
    });
    check();
    window.addEventListener('resize', debounce(check, 150));
  }
  $$('[data-readmore]').forEach(initReadMore);

  /* ---------- Product carousel: prev/next scroll by one card, disabled at either end ---------- */
  function initCarousel(root) {
    if (root.hasAttribute('data-carousel-ready')) return;
    var track = $('[data-carousel-track]', root);
    var prev = $('[data-carousel-prev]', root);
    var next = $('[data-carousel-next]', root);
    if (!track || !prev || !next) return;
    root.setAttribute('data-carousel-ready', '');
    var update = function () {
      var max = track.scrollWidth - track.clientWidth;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max - 2;
    };
    var step = function (dir) {
      var card = track.firstElementChild;
      if (!card) return;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      var perView = Math.max(1, Math.floor((track.clientWidth + gap) / (card.offsetWidth + gap)));
      track.scrollBy({ left: dir * perView * (card.offsetWidth + gap), behavior: reduceMotion ? 'auto' : 'smooth' });
    };
    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    track.addEventListener('scroll', debounce(update, 60), { passive: true });
    // ResizeObserver also fires when a hidden carousel (Recently viewed) is revealed
    if (window.ResizeObserver) new ResizeObserver(update).observe(track);
    else window.addEventListener('resize', debounce(update, 120));
    if (window.MutationObserver) new MutationObserver(update).observe(track, { childList: true });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
    });
    update();
    window.addEventListener('load', update);
  }
  $$('[data-carousel]').forEach(initCarousel);

  /* ---------- Recently viewed (history kept in localStorage, cards via Section Rendering API) ---------- */
  var RECENT_KEY = 'enlighten:recently-viewed';
  function readRecent() {
    try { var list = JSON.parse(localStorage.getItem(RECENT_KEY)); return Array.isArray(list) ? list : []; } catch (e) { return []; }
  }
  function writeRecent(list) {
    try { localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, 12))); } catch (e) {}
  }
  function initRecent(section) {
    var handle = section.getAttribute('data-handle');
    var limit = parseInt(section.getAttribute('data-limit'), 10) || 4;
    var grid = $('[data-recent-grid]', section);
    if (!handle || !grid) return;
    var others = readRecent().filter(function (h) { return h && h !== handle; });
    writeRecent([handle].concat(others));
    if (!others.length) return;
    var root = (T.routes.root || '/').replace(/\/?$/, '/');
    var wanted = others.slice(0, limit + 4);
    Promise.all(wanted.map(function (h) {
      return fetch(root + 'products/' + encodeURIComponent(h) + '?section_id=recently-viewed-card')
        .then(function (r) { return r.ok ? r.text() : (r.status === 404 ? null : ''); })
        .catch(function () { return ''; });
    })).then(function (htmls) {
      var gone = [];
      grid.innerHTML = '';
      htmls.forEach(function (html, i) {
        if (html === null) { gone.push(wanted[i]); return; }
        var card = html && parseHTML(html).querySelector('.shopify-section > *');
        if (!card) return;
        if (grid.children.length < limit) grid.appendChild(document.importNode(card, true));
      });
      if (gone.length) writeRecent(readRecent().filter(function (h) { return gone.indexOf(h) === -1; }));
      section.hidden = grid.children.length === 0;
    });
  }
  $$('[data-recently-viewed]').forEach(initRecent);

  /* ---------- Wishlist (handles kept in localStorage) ---------- */
  var WISHLIST_KEY = 'enlighten:wishlist';
  function readWishlist() {
    try { var list = JSON.parse(localStorage.getItem(WISHLIST_KEY)); return Array.isArray(list) ? list : []; } catch (e) { return []; }
  }
  function writeWishlist(list) {
    try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(list)); } catch (e) {}
    syncWishlistButtons();
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { list: list } }));
  }
  function syncWishlistButtons() {
    var list = readWishlist();
    $$('[data-wishlist-header-count]').forEach(function (el) {
      el.textContent = list.length;
      el.classList.toggle('is-empty', list.length === 0);
    });
    // Header heart only appears once something has been saved
    $$('[data-wishlist-header-link]').forEach(function (el) { el.hidden = list.length === 0; });
    $$('[data-wishlist-toggle]').forEach(function (btn) {
      var on = list.indexOf(btn.getAttribute('data-handle')) > -1;
      var label = btn.getAttribute(on ? 'data-label-remove' : 'data-label-add') || '';
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', String(on));
      btn.setAttribute('aria-label', label);
      btn.setAttribute('title', label);
    });
  }
  function showWishlistToast(text, sub, removed) {
    openToast($('#WishlistToast'), { title: text, sub: sub, removed: removed, duration: 4000 });
  }
  // Product name for the wishlist toast: product page title, or the card title on the wishlist page
  function wishlistProductName(btn) {
    var scope = btn.closest('[data-product-section], .wishlist-item, .details');
    var el = scope && $('.pdp-title, .acc-name, .card-title', scope);
    return el ? el.textContent.trim() : '';
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    var handle = btn.getAttribute('data-handle');
    var list = readWishlist();
    var on = list.indexOf(handle) === -1;
    list = list.filter(function (h) { return h !== handle; });
    if (on) list.unshift(handle);
    writeWishlist(list);
    if (on) {
      btn.classList.remove('is-popping'); void btn.offsetWidth; btn.classList.add('is-popping');
    }
    showWishlistToast(on ? T.strings.wishlistAdded : T.strings.wishlistRemoved, wishlistProductName(btn), !on);
  });
  syncWishlistButtons();
  window.addEventListener('storage', function (e) { if (e.key === WISHLIST_KEY) syncWishlistButtons(); });

  // Wishlist page: render saved products with the same cards as Recently viewed
  function initWishlistPage(section) {
    var grid = $('[data-wishlist-grid]', section);
    var empty = $('[data-wishlist-empty]', section);
    var countEl = $('[data-wishlist-count]', section);
    var heartTpl = $('template[data-wishlist-heart]', section);
    var closeTpl = $('template[data-wishlist-close]', section);
    if (!grid) return;
    grid.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-wishlist-remove]');
      if (!btn) return;
      var handle = btn.getAttribute('data-wishlist-remove');
      var item = btn.closest('.wishlist-item');
      var done = function () {
        writeWishlist(readWishlist().filter(function (h) { return h !== handle; }));
        showWishlistToast(T.strings.wishlistRemoved, wishlistProductName(btn), true);
      };
      if (item && !reduceMotion) { item.classList.add('is-removing'); setTimeout(done, 250); } else { done(); }
    });
    var root = (T.routes.root || '/').replace(/\/?$/, '/');
    var cache = {};
    function render() {
      var list = readWishlist();
      if (countEl) countEl.textContent = list.length ? '(' + list.length + ')' : '';
      if (!list.length) { grid.innerHTML = ''; grid.hidden = true; if (empty) empty.hidden = false; return; }
      if (empty) empty.hidden = true;
      grid.setAttribute('aria-busy', 'true');
      Promise.all(list.map(function (h) {
        if (cache[h] !== undefined) return Promise.resolve(cache[h]);
        return fetch(root + 'products/' + encodeURIComponent(h) + '?section_id=wishlist-card')
          .then(function (r) { return r.ok ? r.text() : (r.status === 404 ? null : ''); })
          .catch(function () { return ''; })
          .then(function (html) { cache[h] = html; return html; });
      })).then(function (htmls) {
        var gone = [];
        grid.innerHTML = '';
        htmls.forEach(function (html, i) {
          if (html === null) { gone.push(list[i]); return; }
          var card = html && parseHTML(html).querySelector('.shopify-section > *');
          if (!card) return;
          var item = document.createElement('div');
          item.className = 'wishlist-item';
          item.appendChild(document.importNode(card, true));
          var remove = document.createElement('button');
          remove.type = 'button';
          remove.className = 'wishlist-btn wishlist-btn--card is-active';
          remove.setAttribute('data-wishlist-toggle', '');
          remove.setAttribute('data-handle', list[i]);
          remove.setAttribute('data-label-add', T.strings.wishlistAdd);
          remove.setAttribute('data-label-remove', T.strings.wishlistRemove);
          remove.innerHTML = heartTpl ? heartTpl.innerHTML : '&hearts;';
          item.appendChild(remove);
          // Explicit text button under the card (the heart above also removes)
          var removeText = document.createElement('button');
          removeText.type = 'button';
          removeText.className = 'wishlist-remove';
          removeText.setAttribute('data-wishlist-remove', list[i]);
          removeText.setAttribute('aria-label', (T.strings.wishlistRemove || 'Remove from wishlist') + ': ' + (($('.acc-name, .card-title', card) || {}).textContent || list[i]).trim());
          removeText.innerHTML = (closeTpl ? closeTpl.innerHTML : '&times;') + '<span>' + (T.strings.wishlistRemoveShort || 'Remove') + '</span>';
          item.appendChild(removeText);
          grid.appendChild(item);
        });
        grid.removeAttribute('aria-busy');
        grid.hidden = grid.children.length === 0;
        if (empty) empty.hidden = grid.children.length > 0;
        syncWishlistButtons();
        if (gone.length) writeWishlist(readWishlist().filter(function (h) { return gone.indexOf(h) === -1; }));
      });
    }
    render();
    document.addEventListener('wishlist:change', render);
  }
  $$('[data-wishlist-page]').forEach(initWishlistPage);

  /* ---------- Predictive search ---------- */
  function initPredictive(wrap) {
    var input = $('input[type="search"]', wrap);
    var results = $('.predictive', wrap);
    if (!input || !results || T.settings.predictiveSearch === false) return;
    var active = -1, items = [];
    function close() { results.hidden = true; results.innerHTML = ''; input.setAttribute('aria-expanded', 'false'); active = -1; items = []; }
    function render(html) {
      var doc = parseHTML(html);
      var inner = $('[data-predictive-results]', doc);
      if (!inner) { close(); return; }
      results.innerHTML = '';
      results.appendChild(inner);
      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      items = $$('.predictive__item', results);
      active = -1;
    }
    var search = debounce(function () {
      var q = input.value.trim();
      if (q.length < 2) { close(); return; }
      var types = ['product', 'collection'];
      if (T.settings.predictivePages !== false) types.push('page');
      if (T.settings.predictiveArticles !== false) types.push('article');
      var url = T.routes.predictiveSearch + '?q=' + encodeURIComponent(q) + '&resources[type]=' + types.join(',') + '&resources[limit]=6&resources[options][prefix]=last&resources[options][unavailable_products]=last&section_id=predictive-search';
      fetchSection(url).then(render).catch(close);
    }, 250);
    input.addEventListener('input', search);
    input.addEventListener('focus', function () { if (input.value.trim().length >= 2 && results.innerHTML) results.hidden = false; });
    input.addEventListener('keydown', function (e) {
      if (results.hidden) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        if (!items.length) return;
        active = e.key === 'ArrowDown' ? (active + 1) % items.length : (active - 1 + items.length) % items.length;
        items.forEach(function (it, i) { it.classList.toggle('is-active', i === active); });
        var link = $('a', items[active]);
        if (link) input.setAttribute('aria-activedescendant', link.id || '');
      } else if (e.key === 'Enter' && active > -1) {
        e.preventDefault();
        var l = $('a', items[active]);
        if (l) window.location.href = l.href;
      } else if (e.key === 'Escape') {
        close();
      }
    });
    document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) close(); });
  }
  $$('[data-predictive-search]').forEach(initPredictive);

  /* ---------- Load more (Section Rendering API) ---------- */
  function sectionUrl(sectionId, page) {
    var params = new URLSearchParams(window.location.search);
    params.set('section_id', sectionId);
    params.set('page', page);
    return window.location.pathname + '?' + params.toString();
  }
  // before: optional element to insert the cards before (earlier pages when the visitor landed on ?page=2+)
  function loadPage(grid, sectionId, page, before) {
    return fetchSection(sectionUrl(sectionId, page)).then(function (html) {
      var doc = parseHTML(html);
      var newGrid = $('[data-grid]', doc);
      if (!newGrid) return [];
      var added = [];
      $$(':scope > *', newGrid).forEach(function (card) {
        if (card.classList.contains('grid-empty')) return;
        grid.insertBefore(card, before || null); added.push(card);
      });
      if (!before) grid.setAttribute('data-page', page);
      return added;
    });
  }
  function initLoadMore(btn) {
    var wrap = btn.closest('[data-load-more-wrap]');
    var section = btn.closest('[data-section-id]');
    var grid = section ? $('[data-grid]', section) : null;
    if (!grid) return;
    btn.addEventListener('click', function () {
      var next = parseInt(btn.getAttribute('data-next-page'), 10);
      var pages = parseInt(btn.getAttribute('data-pages'), 10);
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
      loadPage(grid, btn.getAttribute('data-section-id'), next).then(function (added) {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
        if (next >= pages) { if (wrap) wrap.remove(); } else { btn.setAttribute('data-next-page', next + 1); }
        section.dispatchEvent(new CustomEvent('grid:loaded', { detail: { added: added } }));
        if (added.length) { var f = $('a', added[0]); if (f) f.focus({ preventScroll: true }); }
      }).catch(function () { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); });
    });
  }
  $$('[data-load-more]').forEach(initLoadMore);

  /* ---------- Batteries & Accessories filters ---------- */
  function initAccessories(section) {
    var grid = $('[data-grid]', section);
    var select = $('[data-acc-product]', section);
    var pills = $$('[data-acc-type]', section);
    var empty = $('[data-acc-empty]', section);
    var status = $('[data-acc-status]', section);
    var moreWrap = $('[data-load-more-wrap]', section);
    if (!grid) return;
    var search = $('[data-acc-search]', section);
    var searchClear = $('[data-acc-search-clear]', section);
    var clearBtn = $('[data-acc-clear]', section);
    var state = { type: 'all', product: 'all', words: [] };
    var loadingAll = null;

    function cards() { return $$('.acc-card', grid); }
    function buildProductOptions() {
      if (!select) return;
      var current = select.value;
      var fams = {};
      cards().forEach(function (c) {
        (c.getAttribute('data-products') || '').split('|').forEach(function (f) { f = f.trim(); if (f) fams[f] = true; });
      });
      var names = Object.keys(fams).sort(function (a, b) { return a.localeCompare(b, undefined, { numeric: true }); });
      while (select.options.length > 1) select.remove(1);
      names.forEach(function (n) { var o = document.createElement('option'); o.value = n; o.textContent = n; select.appendChild(o); });
      if (names.indexOf(current) > -1) select.value = current;
    }
    function apply() {
      var visible = 0;
      cards().forEach(function (card) {
        var type = card.getAttribute('data-type') || '';
        var products = (card.getAttribute('data-products') || '').split('|');
        var text = card.getAttribute('data-search') || '';
        var ok = (state.type === 'all' || type.toLowerCase() === state.type.toLowerCase()) &&
                 (state.product === 'all' || products.indexOf(state.product) > -1) &&
                 state.words.every(function (w) { return text.indexOf(w) > -1; });
        card.hidden = !ok;
        if (ok) visible++;
      });
      if (empty) empty.hidden = visible > 0;
      var filtering = state.type !== 'all' || state.product !== 'all' || state.words.length > 0;
      if (clearBtn) clearBtn.hidden = !filtering;
      if (moreWrap) moreWrap.hidden = filtering;
      if (status) status.textContent = filtering ? visible + ' of ' + cards().length : '';
    }
    function ensureAllLoaded() {
      var pages = parseInt(grid.getAttribute('data-pages'), 10) || 1;
      var page = parseInt(grid.getAttribute('data-page'), 10) || 1;
      var startPage = parseInt(grid.getAttribute('data-start-page') || page, 10);
      if (!grid.hasAttribute('data-start-page')) grid.setAttribute('data-start-page', page);
      if (page >= pages && startPage <= 1) return Promise.resolve();
      if (loadingAll) return loadingAll;
      if (status) status.textContent = T.strings.loading || 'Loading…';
      var sectionId = section.getAttribute('data-section-id');
      var firstCard = grid.firstElementChild;
      var chain = Promise.resolve();
      // Landed on ?page=2+ (paginated collection page): load the earlier pages in front, in order
      for (var b = 1; b < startPage; b++) {
        (function (pg) { chain = chain.then(function () { return loadPage(grid, sectionId, pg, firstCard); }); })(b);
      }
      for (var p = page + 1; p <= pages; p++) {
        (function (pg) { chain = chain.then(function () { return loadPage(grid, sectionId, pg); }); })(p);
      }
      loadingAll = chain.then(function () { if (moreWrap) moreWrap.remove(); moreWrap = null; buildProductOptions(); });
      return loadingAll;
    }
    function change() { ensureAllLoaded().then(apply, apply); }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        state.type = pill.getAttribute('data-acc-type');
        pills.forEach(function (p) { var on = p === pill; p.classList.toggle('is-active', on); p.setAttribute('aria-pressed', String(on)); });
        change();
      });
    });
    if (select) select.addEventListener('change', function () { state.product = select.value; change(); });
    if (search) {
      var onSearch = function () {
        state.words = search.value.toLowerCase().replace(/chameleon/g, 'chamaeleon').split(/\s+/).filter(Boolean);
        if (searchClear) searchClear.hidden = !search.value;
        change();
      };
      search.addEventListener('input', debounce(onSearch, 120));
      search.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && search.value) { e.preventDefault(); search.value = ''; onSearch(); }
        if (e.key === 'Enter') e.preventDefault();
      });
      if (searchClear) searchClear.addEventListener('click', function () { search.value = ''; onSearch(); search.focus(); });
    }
    // Clear: back to All / All Products / empty search
    if (clearBtn) clearBtn.addEventListener('click', function () {
      state.type = 'all'; state.product = 'all'; state.words = [];
      pills.forEach(function (p) { var on = p.getAttribute('data-acc-type') === 'all'; p.classList.toggle('is-active', on); p.setAttribute('aria-pressed', String(on)); });
      if (select) select.value = 'all';
      if (search) search.value = '';
      if (searchClear) searchClear.hidden = true;
      apply();
      var allPill = pills.filter(function (p) { return p.getAttribute('data-acc-type') === 'all'; })[0];
      if (allPill) allPill.focus({ preventScroll: true });
    });
    section.addEventListener('grid:loaded', function () { buildProductOptions(); apply(); });
    buildProductOptions();
    apply();
  }
  $$('[data-accessories]').forEach(initAccessories);

  /* ---------- Steppers (product + cart) ---------- */
  document.addEventListener('click', function (e) {
    var dec = e.target.closest('[data-qty-dec]'), inc = e.target.closest('[data-qty-inc]');
    if (!dec && !inc) return;
    var stepper = (dec || inc).closest('[data-stepper]');
    var input = $('[data-qty]', stepper);
    if (!input) return;
    var min = parseInt(input.min, 10); if (isNaN(min)) min = 0;
    var v = parseInt(input.value, 10) || 0;
    v = dec ? Math.max(min, v - 1) : v + 1;
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Product form ---------- */
  function initProduct(section) {
    var jsonEl = $('[data-product-json]', section);
    var form = $('[data-product-form]', section);
    var product = jsonEl ? JSON.parse(jsonEl.textContent) : null;
    var gallery = $('[data-gallery]', section);

    function showMedia(id) {
      if (!gallery || !id) return;
      var slides = $$('.gallery-slide', gallery), thumbs = $$('[data-thumb]', gallery);
      var found = false;
      slides.forEach(function (s) { var on = s.getAttribute('data-media-id') === String(id); s.hidden = !on; s.classList.toggle('is-active', on); if (on) found = true; });
      if (!found && slides.length) { slides.forEach(function (s, i) { s.hidden = i !== 0; s.classList.toggle('is-active', i === 0); }); }
      thumbs.forEach(function (t) { var on = t.getAttribute('data-media-id') === String(id); t.classList.toggle('is-active', on); t.setAttribute('aria-selected', String(on)); });
      // Thumbnail carousel (more than 4 images): bring the active thumb into view without scrolling the page
      var track = $('.gallery-thumbs--carousel', gallery);
      var active = track && $('.thumb.is-active', track);
      if (active) {
        var left = active.offsetLeft - track.offsetLeft, right = left + active.offsetWidth;
        if (left < track.scrollLeft || right > track.scrollLeft + track.clientWidth) {
          track.scrollTo({ left: left, behavior: reduceMotion ? 'auto' : 'smooth' });
        }
      }
    }
    if (gallery) {
      $$('[data-thumb]', gallery).forEach(function (t) { t.addEventListener('click', function () { showMedia(t.getAttribute('data-media-id')); }); });
    }
    if (!form || !product) return;

    var idInput = $('[data-variant-id]', form);
    var qtyInput = $('[data-qty]', form);
    var totalEl = $('[data-total]', section);
    var skuEls = $$('[data-sku]', section);
    var availEl = $('[data-availability]', section);
    var availText = $('[data-availability-text]', section);
    var stockEl = $('[data-stock-count]', section);
    var addBtn = $('[data-add-to-cart]', form);
    var addLabel = $('[data-add-label]', form);
    var errorEl = $('[data-form-error]', form);
    var showTotal = totalEl && totalEl.hasAttribute('data-price');

    function selectedOptions() {
      var opts = [];
      product.options.forEach(function (name, i) {
        var checked = $('input[name="' + CSS.escape(name) + '"]:checked', form);
        opts[i] = checked ? checked.value : null;
      });
      return opts;
    }
    function findVariant() {
      if (product.hasOnlyDefaultVariant) return product.variants[0];
      var opts = selectedOptions();
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i], match = true;
        for (var j = 0; j < opts.length; j++) { if (opts[j] !== null && v.options[j] !== opts[j]) { match = false; break; } }
        if (match) return v;
      }
      return null;
    }
    function render() {
      var v = findVariant();
      var qty = Math.max(1, parseInt(qtyInput ? qtyInput.value : 1, 10) || 1);
      if (!v) {
        if (addBtn) { addBtn.disabled = true; }
        if (addLabel) addLabel.textContent = T.strings.unavailable;
        if (availEl) { availText.textContent = T.strings.unavailable; availEl.classList.add('availability--out'); }
        if (stockEl) stockEl.hidden = true;
        return;
      }
      idInput.value = v.id;
      skuEls.forEach(function (el) { el.textContent = v.sku || ''; });
      if (totalEl) {
        if (showTotal) totalEl.textContent = formatMoney(v.price * qty);
        else totalEl.innerHTML = '<div class="price"><span class="price__current">' + formatMoney(v.price) + '</span>' + (v.compare_at_price > v.price ? ' <s class="price__compare">' + formatMoney(v.compare_at_price) + '</s>' : '') + '</div>';
      }
      if (availEl) { availText.textContent = v.available ? availEl.getAttribute('data-in-stock') || 'In stock' : T.strings.soldOut; availEl.classList.toggle('availability--out', !v.available); }
      if (stockEl) { stockEl.textContent = v.stock_label || ''; stockEl.hidden = !v.stock_label; }
      if (addBtn) { addBtn.disabled = !v.available; }
      if (addLabel) addLabel.textContent = v.available ? T.strings.addToCart : T.strings.soldOut;
      // Sticky add to cart bar mirrors the selected variant
      var sVariant = $('[data-sticky-variant]', section), sPrice = $('[data-sticky-price]', section);
      var sAdd = $('[data-sticky-add]', section), sAddLabel = $('[data-sticky-add-label]', section);
      if (sVariant && !product.hasOnlyDefaultVariant) sVariant.textContent = v.title;
      if (sPrice) sPrice.textContent = formatMoney(v.price);
      if (sAdd) sAdd.disabled = !v.available;
      if (sAddLabel) sAddLabel.textContent = v.available ? T.strings.addToCart : T.strings.soldOut;
      $$('[data-option-value]', section).forEach(function (el) { var idx = parseInt(el.getAttribute('data-option-value'), 10) - 1; el.textContent = v.options[idx] || ''; });
      if (v.featured_media_id) showMedia(v.featured_media_id);
      if (!product.hasOnlyDefaultVariant && window.history.replaceState) {
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url.toString());
      }
    }
    if (availEl) availEl.setAttribute('data-in-stock', availText.textContent.trim());
    $$('[data-option-input]', form).forEach(function (i) { i.addEventListener('change', render); });
    if (qtyInput) qtyInput.addEventListener('change', render);
    render();

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (addBtn && addBtn.disabled) return;
      if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
      var data = new FormData(form);
      addBtn.classList.add('is-loading');
      fetch(T.routes.cartAdd + '.js', { method: 'POST', body: data, headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
        .then(function (res) {
          addBtn.classList.remove('is-loading');
          if (!res.ok) { if (errorEl) { errorEl.textContent = res.json.description || res.json.message || T.strings.cartError; errorEl.hidden = false; } return; }
          updateCartCount();
          if (T.settings.cartNotification) {
            var thumb = res.json.featured_image && res.json.featured_image.url ? res.json.featured_image.url : res.json.image;
            if (thumb) thumb += (thumb.indexOf('?') > -1 ? '&' : '?') + 'width=120';
            var variantTitle = res.json.variant_title && res.json.variant_title !== 'Default Title' ? ' · ' + res.json.variant_title : '';
            showToast(T.strings.addedToCart, (res.json.product_title || '') + variantTitle, thumb);
          }
          else window.location.href = T.routes.cart;
        })
        .catch(function () { addBtn.classList.remove('is-loading'); if (errorEl) { errorEl.textContent = T.strings.cartError; errorEl.hidden = false; } });
    });
  }
  $$('[data-product-section]').forEach(initProduct);

  /* ---------- Product recommendations ---------- */
  $$('[data-recommendations]').forEach(function (el) {
    fetchSection(el.getAttribute('data-url')).then(function (html) {
      var doc = parseHTML(html);
      var inner = $('.related', doc);
      if (inner) {
        el.replaceWith(inner);
        $$('[data-carousel]', inner).forEach(initCarousel);
      } else {
        el.remove();
      }
    }).catch(function () { el.remove(); });
  });

  /* ---------- Cart page ---------- */
  function initCart(section) {
    var sectionId = section.getAttribute('data-section-id');
    var errorEl = $('[data-cart-error]', section);
    function change(line, quantity, row) {
      if (row) row.classList.add('is-updating');
      fetch(T.routes.cartChange + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity, sections: [sectionId] })
      }).then(function (r) { return r.json(); }).then(function (json) {
        var html = json.sections && json.sections[sectionId];
        if (html) {
          var doc = parseHTML(html);
          var fresh = $('[data-cart-section]', doc);
          if (fresh) { section.replaceWith(fresh); initCart(fresh); }
        }
        updateCartCount();
      }).catch(function () { if (row) row.classList.remove('is-updating'); if (errorEl) { errorEl.textContent = T.strings.cartError; errorEl.hidden = false; } });
    }
    $$('[data-line-qty]', section).forEach(function (input) {
      input.addEventListener('change', debounce(function () {
        change(parseInt(input.getAttribute('data-line-qty'), 10), Math.max(0, parseInt(input.value, 10) || 0), input.closest('.cart-item'));
      }, 300));
    });
    $$('[data-remove-item]', section).forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var row = link.closest('.cart-item');
        change(parseInt(row.getAttribute('data-line'), 10), 0, row);
      });
    });
  }
  $$('[data-cart-section]').forEach(initCart);

  /* ---------- Collection sort ---------- */
  $$('[data-sort-select]').forEach(function (sel) {
    sel.addEventListener('change', function () { sel.closest('form').submit(); });
  });

  /* ---------- Customer: recover toggle, addresses ---------- */
  $$('[data-recover-toggle]').forEach(function (a) {
    a.addEventListener('click', function (e) { e.preventDefault(); var r = $('#recover'); if (r) { r.hidden = !r.hidden; if (!r.hidden) $('input', r).focus(); } });
  });
  if (window.location.hash === '#recover') { var rec = $('#recover'); if (rec) rec.hidden = false; }
  $$('[data-address-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () { var el = document.getElementById(btn.getAttribute('data-address-toggle')); if (el) el.hidden = !el.hidden; });
  });
  $$('[data-confirm]').forEach(function (btn) {
    btn.addEventListener('click', function (e) { if (!window.confirm(btn.getAttribute('data-confirm'))) e.preventDefault(); });
  });
  function initCountrySelectors() {
    if (!window.Shopify || !Shopify.CountryProvinceSelector) return;
    $$('[data-address-country-select]').forEach(function (sel) {
      var id = sel.getAttribute('data-address-id');
      var prov = document.getElementById('AddressProvince-' + id);
      if (!prov || sel.getAttribute('data-init')) return;
      sel.id = 'AddressCountry-' + id;
      sel.setAttribute('data-init', '1');
      new Shopify.CountryProvinceSelector(sel.id, prov.id, { hideElement: prov.closest('.form-field') ? prov.closest('.form-field').id || prov.id : prov.id });
      var def = sel.getAttribute('data-default'); if (def) { sel.value = def; sel.dispatchEvent(new Event('change')); }
      var pdef = prov.getAttribute('data-default'); if (pdef) prov.value = pdef;
    });
  }
  window.addEventListener('load', initCountrySelectors);

  /* ---------- Theme editor hooks ---------- */
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target;
    $$('[data-load-more]', s).forEach(initLoadMore);
    $$('[data-accessories]', s).forEach(initAccessories);
    $$('[data-product-section]', s).forEach(initProduct);
    $$('[data-specs]', s).forEach(initSpecs);
    $$('[data-carousel]', s).forEach(initCarousel);
    $$('[data-readmore]', s).forEach(initReadMore);
    initParallax(s);
    $$('[data-product-section]', s).forEach(initStickyAtc);
    $$('[data-product-section]', s).forEach(initZoom);
    $$('[data-recently-viewed]', s).forEach(initRecent);
    $$('[data-cart-section]', s).forEach(initCart);
    $$('[data-predictive-search]', s).forEach(initPredictive);
    syncHeaderHeight();
  });

  updateCartCount();
})();
